var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 959,
    viewBox: "0 0 1920 959",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2221_43877)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 959,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2221_43877)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 959,
    fill: "#A496DC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 1920,
    height: 959,
    transform: "matrix(-1 0 0 1 1920 0)",
    fill: "url(#paint0_linear_2221_43877)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M924.858 294.453H912.479V260H924.858C935.181 260 941.534 266.448 941.534 277.226C941.534 287.981 935.181 294.453 924.858 294.453ZM920.42 287.505H924.577C930.37 287.529 933.546 284.698 933.546 277.226C933.546 269.732 930.37 266.924 924.484 266.9H920.42V287.505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.76 260V294.453H955.819V260H963.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.845 294.453H978.466V260H990.845C1001.17 260 1007.52 266.448 1007.52 277.226C1007.52 287.981 1001.17 294.453 990.845 294.453ZM986.407 287.505H990.564C996.357 287.529 999.533 284.698 999.533 277.226C999.533 269.732 996.357 266.924 990.471 266.9H986.407V287.505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821 347.595V324.473H829.592C834.835 324.473 837.631 327.699 837.646 332.138C837.631 336.561 834.804 339.771 829.529 339.771H825.106V347.595H821ZM825.106 336.353H828.96C832.056 336.338 833.445 334.581 833.445 332.138C833.445 329.663 832.056 327.954 828.96 327.954H825.106V336.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.136 347.595V324.473H861.242V344.082H871.35V347.595H857.136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.598 347.595H890.208L898.262 324.473H903.316L911.403 347.595H907.012L905.101 341.878H896.494L894.598 347.595ZM897.599 338.525H903.996L900.884 329.2H900.695L897.599 338.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.501 327.954V324.473H944.727V327.954H937.683V347.595H933.577V327.954H926.501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.122 347.595V324.473H978.778V327.954H968.228V334.278H977.768V337.759H968.228V347.595H964.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.83 336.034C1018.85 343.507 1014.33 347.914 1008.34 347.914C1002.33 347.914 997.841 343.491 997.857 336.034C997.841 328.561 1002.33 324.154 1008.34 324.154C1014.33 324.154 1018.85 328.561 1018.83 336.034ZM1002 336.034C1001.98 341.32 1004.62 344.178 1008.34 344.178C1012.09 344.178 1014.71 341.32 1014.69 336.034C1014.71 330.749 1012.09 327.89 1008.34 327.89C1004.62 327.89 1001.98 330.749 1002 336.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.67 347.595V324.473H1047.26C1052.5 324.473 1055.3 327.443 1055.31 331.85C1055.3 334.996 1053.88 337.328 1051.19 338.429L1056.14 347.595H1051.56L1047.07 339.132H1042.77V347.595H1038.67ZM1042.77 335.651H1046.63C1049.72 335.667 1051.11 334.326 1051.11 331.85C1051.11 329.391 1049.72 327.954 1046.63 327.954H1042.77V335.651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.02 324.473H1080.08L1086.87 341.272H1087.15L1093.95 324.473H1099V347.595H1095.05V331.691H1094.83L1088.48 347.531H1085.54L1079.19 331.627H1079V347.595H1075.02V324.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip2_2221_43877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M903.279 807.696C901.148 806.064 898.484 805.095 895.591 805.095C888.648 805.095 883 810.677 883 817.545C883 824.413 888.648 830 895.591 830C902.534 830 908.182 824.413 908.182 817.545H908.194V796.283H903.279V807.696ZM895.591 825.144C891.358 825.144 887.915 821.738 887.915 817.55C887.915 813.363 891.358 809.957 895.591 809.957C899.824 809.957 903.267 813.363 903.267 817.55C903.267 821.738 899.824 825.144 895.591 825.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.378 805.095C947.485 805.095 944.816 806.07 942.69 807.696V796.283H937.775V817.545H937.787C937.787 824.413 943.435 830 950.378 830C957.321 830 962.969 824.413 962.969 817.545C962.969 810.677 957.321 805.089 950.378 805.089V805.095ZM950.378 825.144C946.145 825.144 942.702 821.738 942.702 817.55C942.702 813.363 946.145 809.957 950.378 809.957C954.611 809.957 958.054 813.363 958.054 817.55C958.054 821.738 954.611 825.144 950.378 825.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.41 805.095C1018.47 805.095 1012.82 810.683 1012.82 817.551C1012.82 824.419 1018.47 830.006 1025.41 830.006C1032.35 830.006 1038 824.419 1038 817.551C1038 810.683 1032.35 805.095 1025.41 805.095ZM1025.41 825.144C1021.18 825.144 1017.73 821.738 1017.73 817.551C1017.73 813.363 1021.18 809.957 1025.41 809.957C1029.64 809.957 1033.09 813.363 1033.09 817.551C1033.09 821.738 1029.64 825.144 1025.41 825.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.985 805.095C916.042 805.095 910.394 810.683 910.394 817.551C910.394 824.419 916.042 830.006 922.985 830.006C925.872 830.006 928.536 829.037 930.661 827.411V829.7H935.576V817.551C935.576 810.683 929.928 805.095 922.985 805.095ZM922.985 825.144C918.751 825.144 915.309 821.738 915.309 817.551C915.309 813.363 918.751 809.957 922.985 809.957C927.218 809.957 930.661 813.363 930.661 817.551C930.661 821.738 927.218 825.144 922.985 825.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.027 825.138C993.794 825.138 990.351 821.732 990.351 817.545C990.351 813.357 993.794 809.951 998.027 809.951V805.089C997.764 805.089 997.506 805.101 997.254 805.118C996.068 805.112 995.106 804.16 995.106 802.987C995.106 801.814 996.068 800.862 997.254 800.862C998.439 800.862 999.402 801.814 999.402 802.987H1004.32C1004.32 799.134 1001.15 796 997.254 796C993.358 796 990.191 799.134 990.191 802.987C990.191 804.455 990.655 805.815 991.439 806.942C987.842 809.135 985.442 813.068 985.442 817.545C985.442 821.732 981.999 825.138 977.766 825.138C973.532 825.138 970.089 821.732 970.089 817.545C970.089 813.357 973.532 809.951 977.766 809.951V805.089C977.502 805.089 977.244 805.101 976.992 805.118C975.806 805.112 974.844 804.16 974.844 802.987C974.844 801.814 975.806 800.862 976.992 800.862C978.178 800.862 979.14 801.814 979.14 802.987H984.055C984.055 799.134 980.888 796 976.992 796C973.097 796 969.929 799.134 969.929 802.987C969.929 804.455 970.393 805.815 971.178 806.942C967.58 809.135 965.18 813.068 965.18 817.545C965.18 824.413 970.828 830 977.771 830C981.924 830 985.608 828 987.905 824.928C990.202 828.005 993.885 830 998.038 830C1004.98 830 1010.63 824.413 1010.63 817.545H1005.71C1005.71 821.732 1002.27 825.138 998.038 825.138H998.027Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2221_43877",
    x1: 1920,
    y1: 959,
    x2: 716.109,
    y2: 39.5747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BECA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2221_43877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 959,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2221_43877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 959,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2221_43877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 34,
    fill: "white",
    transform: "translate(883 796)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultHorizontal);
export default __webpack_public_path__ + "static/media/default_horizontal.ae970d88eb462fb7b9ad93055c20de8a.svg";
export { ForwardRef as ReactComponent };